import { useSelector } from 'react-redux';
import { Icon, Surface, Txt } from '@vst/beam';
import { ShoppingCart } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { selectBillingAccount, selectEtf } from '@app/redux';
import { getNextBillCycleDate } from '@app/utils';

import styles from './index.module.scss';

const Summary = () => {
  const { t } = useTranslation('Disconnect');
  const { data } = useSelector(selectEtf);
  const totalEtf = data?.calculatedEtf?.value ?? 0;

  const billingAccount = useSelector(selectBillingAccount);
  const serviceEndLoading = billingAccount?.loading;
  const nextBillingCycleDate = getNextBillCycleDate(billingAccount);

  return (
    <Surface className={styles['summaryContent']}>
      <div>
        <Icon data-cy="shopping-cart-icon" icon={ShoppingCart} size={24} color="gray_600" />
        {serviceEndLoading ? (
          <div className={styles['loadingRow']} />
        ) : (
          <>
            <Txt variant="smallRegular" mr="4px">
              {t('cart.serviceEnd')}
            </Txt>
            <Txt variant="smallBold">{nextBillingCycleDate}</Txt>
          </>
        )}
      </div>
      {totalEtf ? (
        <div>
          <Txt variant="smallRegular" mr="4px">
            {t('cart.oneTimeFee')}
          </Txt>
          <Txt variant="smallBold">${totalEtf}</Txt>
        </div>
      ) : null}
    </Surface>
  );
};

export default Summary;
